import * as spUploader from '@umu/umu-upload';
import { EMediaType, IUploadPayloadData } from '@umu/umu-types';

let videoExt = '';
videoExt = 'avi,flv,f4v,mkv,mov,mp4,mpeg,ts,mts,wmv,dv,m2v,m4v,mp3';

export const MediaTypeMap = {
    picweike: 'jpg,png,gif,jpeg',
    image: 'jpg,png,gif,jpeg',
    videoweike: videoExt,
    docweike: 'ppt,xls,doc,pdf,pptx,xlsx,docx,xlsm,txt',
    imageweike: 'jpg,png,gif,jpeg',
    imagewall: 'jpg,png,gif,jpeg',
    graffiti: 'log',
    audio: 'mp3',
    subtitle: 'srt',
    aiTools: '', //  aitools 的后缀是动态的，这里是为了修复 ts 类型
    default: 'default',
};

interface IOptions {
    fileExt: string;
    mediaType: EMediaType;
    teacherId: string;
    fileName?: string;
    key?: string;
    extend_info?: string;
    progress?(progress: any, uploadPayloadData: IUploadPayloadData): void;
}

export const expandAccept = spUploader.expandAccept;
export function expandMediaAccept(mediaType: EMediaType | EMediaType[]) {
    let accept = '';
    if (Array.isArray(mediaType)) {
        accept = mediaType
            .map((type) => MediaTypeMap?.[type] || '')
            .filter(Boolean)
            .join(',');
    } else {
        accept = MediaTypeMap?.[mediaType] || '';
    }
    accept = accept
        .split(',')
        .map((item) => (item.includes('.') ? item : `${item},.${item}`))
        .join(',');
    return spUploader.expandAccept(accept);
}

export default function upload(file: Blob | File, options: IOptions): Promise<IUploadPayloadData> {
    // blob
    if (!(file instanceof File)) {
        const ext = String(options.fileExt || '').toLowerCase();
        const name = `${options.fileName}.${ext}` || `${Date.now()}.${Math.random().toString().substr(2, 4)}.${ext}`;
        try {
            file = new File([file], name, { type: file.type });
        } catch (error) {
            (file as any).name = name;
        }
    }

    let system = 'cn';
    system = '!cn';
    const uplpad = spUploader.uploadByProvider;
    return new Promise((resolve, reject) => {
        const uploadParams = {
            progress: options.progress,
            success: (_e: unknown, payload: IUploadPayloadData) => {
                resolve(payload);
            },
            error: reject,
            signature: {
                media_type: options.mediaType,
                id: options.teacherId,
            },
            extend_info: options.extend_info,
        };
        if (system === 'cn') {
            uplpad(file, uploadParams, 'cos');
        } else {
            spUploader.isInWhiteList().then((data) => {
                if (data.status === 1) {
                    spUploader.uploadAws(file, uploadParams);
                } else {
                    uplpad(file, uploadParams, 'cos');
                }
            });
        }
    });
}

interface IEncodeResult {
    blob: Blob | File;
    ext: string;
    previewUrl: string;
    fileName: string;
    mediaType: EMediaType;
    teacherId: string;
    uniqueId?: string;
    onProgress?: (fileName: string, progress: any) => void;
}

interface IPayloadData {
    resourceId: number | string;
    url: string;
    fileSize: number;
    previewUrl: string;
    fileName: string;
    uniqueId?: string;
}

export function getUploadResult({
    blob,
    ext,
    previewUrl,
    fileName,
    mediaType,
    teacherId,
    uniqueId,
    onProgress,
}: IEncodeResult): Promise<IPayloadData> {
    try {
        return upload(blob, {
            fileExt: ext,
            mediaType,
            teacherId,
            fileName,
            progress: (progress) => {
                if (onProgress instanceof Function) {
                    onProgress(fileName, progress);
                }
            },
        })
            .then((payloadData) => {
                return {
                    resourceId: payloadData.resource_id,
                    url: payloadData.path,
                    fileSize: blob.size,
                    previewUrl,
                    fileName,
                    uniqueId,
                };
            })
            .catch((e) => {
                throw e;
            });
    } catch (e) {
        throw e;
    }
}

export type { IEncodeResult, IPayloadData, IOptions, IUploadPayloadData };

export { default as UploadQueue, EUploadStatus } from './uploaderQueue';

export { default as UploaderDialog } from './components/uploaderDialog/uploaderDialog';

export type {
    IUploadDialog,
    IUploadDialogOptions,
    IUploadDialogState,
    IUploadQueueOptions,
} from './components/uploaderDialog/uploaderDialog';
